import { makeStyles } from "@material-ui/core/styles"
import React from "react"
import PropTypes from "prop-types"

import ProjectGrid from "./ProjectGrid"

import Container from "@material-ui/core/Container"
import Grid from "@material-ui/core/Grid"

const useStyles = makeStyles((theme) => ({
  cardGrid: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    padding: 0,
  },
}))

const ProjectsGrid = ({ projectList, allProjPics, status }) => {
  const classes = useStyles()

  return (
    <Container className={classes.cardGrid} maxWidth="lg">
      <Grid container spacing={3}>
        {projectList.map(
          (proj) =>
            proj.status === status && (
              <ProjectGrid
                allProjPics={allProjPics}
                imgHeight={120}
                proj={proj}
              />
            )
        )}
      </Grid>
    </Container>
  )
}

ProjectsGrid.propTypes = {
  projectList: PropTypes.array.isRequired,
  allProjPics: PropTypes.array.isRequired,
}

export default ProjectsGrid
